const whatsapp = require.context('.', true, /\.js$/)
whatsapp.keys().forEach(whatsapp)
